/* eslint-disable react/require-default-props */

import React from 'react';
import { connect } from 'react-redux';

import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import ReportTableContainer from 'reports/Common/ReportTable';
import { convertPaymentTypeDataToCashCardSplitTableData } from 'reports/utils';

const CashCardSplitStylistTable = ({ currency, stylists, startDate, endDate }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div id="payment-by-total">
        <ReportTableContainer
          startDate={startDate}
          endDate={endDate}
          title={t('businessReports.payments.stylistTable.totalRevenueTitle')}
          data={{
            rows: convertPaymentTypeDataToCashCardSplitTableData(
              stylists.filter((s) => s.total_revenue !== 0),
              'total',
              currency,
              t('businessReports.payments.stylistTable.totalFooterLabel'),
              t,
            ),
          }}
        />
      </div>
      <div id="payment-by-services">
        <ReportTableContainer
          startDate={startDate}
          endDate={endDate}
          title={t('businessReports.payments.stylistTable.servicesTitle')}
          data={{
            rows: convertPaymentTypeDataToCashCardSplitTableData(
              stylists.filter((s) => s.total_revenue !== 0),
              'services',
              currency,
              t('businessReports.payments.stylistTable.servicesFooterLabel'),
              t,
            ),
          }}
        />
      </div>
      <div id="payment-by-products">
        <ReportTableContainer
          startDate={startDate}
          endDate={endDate}
          title={t('businessReports.payments.stylistTable.productsTitle')}
          data={{
            rows: convertPaymentTypeDataToCashCardSplitTableData(
              stylists.filter((s) => s.total_revenue !== 0),
              'products',
              currency,
              t('businessReports.payments.stylistTable.productsFooterLabel'),
              t,
            ),
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currency: selectCurrentSalonCurrency(state),
});

const CashCardSplitStylistTableHoc = connect(mapStateToProps)(CashCardSplitStylistTable);

export default CashCardSplitStylistTableHoc;
